import { Box, FlexColumn, FlexRow, SingleSelect } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import css from "./CustomViewOptions.module.css";
import { isDefined, isNullOrUndefined } from "csi/utility/coreUtility";

const PrintOptionPaperSizeAndOrientation: FunctionComponent = observer((props) => {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		dropDownOptions,
		options: {
			printOrientation,
			printPaper,
		},
		selectedPrintOrientation,
		selectedPrintPaper,
		setPrintOrientation,
		setPrintPaper,
	} = optionsStore;

	const { paperOrientations, paperSizes } = dropDownOptions;

	if (isNullOrUndefined(printOrientation) && isNullOrUndefined(printPaper)) {
		return;
	}

	return (
		<Box 
			className={css.container}
			data-csi-automation="PrintOptionPaperSizeAndOrientation"
		>
			<FlexRow>
				<>
					{isDefined(printPaper) && (
						<FlexColumn className={css.optionLeft}>
							<SingleSelect
								disableClearable
								fullWidth
								labelRes="CustomViewPrintPaperSize"
								onChange={setPrintPaper}
								options={paperSizes}
								value={selectedPrintPaper}
							/>
						</FlexColumn>
					)}
					{isDefined(printOrientation) && (
						<FlexColumn className={css.optionRightSelect}>
							<SingleSelect
								disableClearable
								fullWidth
								labelRes="PrintOrientation"
								onChange={setPrintOrientation}
								options={paperOrientations}
								value={selectedPrintOrientation}
							/>
						</FlexColumn>
					)}
				</>
			</FlexRow>
		</Box>
	);
});

export default PrintOptionPaperSizeAndOrientation;